jQuery(document).ready(function($) {
    /**
     * Function to set handle the navigation through the steps
     */
    $(document).on('click', '[data-wpgu-step-goto]', function(e) {
        e.preventDefault();
        
        var current = $(this).data('wpgu-step-current');
        var goto    = $(this).data('wpgu-step-goto');

        $('#wpgu-onboarding-step-' + goto).removeClass('wpgu-slide-out-left');
        $('#wpgu-onboarding-step-' + goto).removeClass('wpgu-slide-out-right');
        $('#wpgu-onboarding-step-' + goto).removeClass('wpgu-step-default');

        $('#wpgu-onboarding-step-' + current).removeClass('wpgu-step-active');
        $('#wpgu-onboarding-step-' + current).removeClass('wpgu-slide-in-left');
        $('#wpgu-onboarding-step-' + current).removeClass('wpgu-slide-in-right');

        if (current < goto) {
            $('#wpgu-onboarding-step-' + current).addClass('wpgu-slide-out-left');
            $('#wpgu-onboarding-step-' + current).addClass('wpgu-slided-out');
            $('#wpgu-onboarding-step-' + goto).addClass('wpgu-slide-in-right');
        } else {
            $('#wpgu-onboarding-step-' + current).addClass('wpgu-slide-out-right');
            $('#wpgu-onboarding-step-' + current).removeClass('wpgu-slided-out');
            $('#wpgu-onboarding-step-' + goto).addClass('wpgu-slide-in-left');
        }

        $('#wpgu-onboarding-step-' + goto).addClass('wpgu-step-active');

        // update progress bar
        if ($('[data-wpgu-progress]').length) {
            var steps = $('[data-wpgu-progress]').data('wpgu-progress-steps');
            var progress_width = (100 / steps) * goto;
            $('[data-wpgu-progress]').width(progress_width + '%');

            if (goto === 1) {
                $('[data-wpgu-progress]').addClass('wpgu-onboarding-progress-hide');
            } else {
                $('[data-wpgu-progress]').removeClass('wpgu-onboarding-progress-hide');
            }
        }

        if(!$(this).hasClass('wpgu-onboarding-step-back') && !$(this).hasClass('wpgu-onboarding-step-skip')) {
            saveOnboardingData(current);
        }
    });


    /**
     * Set a cookie to hide the popup or cta block for a set amount of time
     */
    $(document).on('click', '[data-wpgu-onboarding-close]', function(e) {
        e.preventDefault();
        
        var go_to_url = $(this).attr('href');

        $.ajax({
            url: themevars.ajaxurl,
            data: {
                action: 'wpgu_set_onboarding_close_cookie',
            },
            type: 'POST',
            dataType: 'json',
            success: function (data) {
                if (go_to_url) {
                    window.location.replace(go_to_url);
                }
            }
        });
    });


    /**
     * Save the onboarding data in the final step and then redirect to end_url
     */
    $('#submit-onboarding').on('click', function(e) {
        e.preventDefault();

        var current = $(this).data('wpgu-step-current');
        $(this).addClass('saving');

        saveOnboardingData(current, true);
    });


    /**
     * save the onboarding data in the database with an ajax call
     */
    function saveOnboardingData(current = 0, end = false) {

        if(current === 0) {
            return;
        }

        var post_data = {};
        var form_data = $('#wpgu-onboarding-form').serializeArray();
        
        for (var i = 0; i < form_data.length; i++) {
            if (form_data[i]['name'].endsWith('[]')) {
                var name = form_data[i]['name'];
                name = name.substring(0, name.length - 2);
                if (!(name in post_data)) {
                    post_data[name] = [];
                }
                post_data[name].push(form_data[i]['value']);
            } else {
                post_data[form_data[i]['name']] = form_data[i]['value'];
            }
        }

        $.ajax( {
            url      : wpguvars.ajaxurl,
            data     : {
                action: 'wpgu_save_onboarding_data',
                post_id: wpguvars.post_id,
                step_current: current,
                post_data: post_data,
                end: end
            },
            type     : 'POST',
            dataType : 'json'
        } ).done( function ( response ) {
            $( document ).trigger( "wpgu-onboarding-saved" );

            if (response.data.end_url) {
                window.location.replace(response.data.end_url);
            }
        });
    }
}); // close DOM ready
